import React, {Suspense} from "react";
import { PostulationPage } from "@rankmi/ats-app";

const Postulation = ({ orgToken, token, tenant }) => {
  return (
    <Suspense fallback="">
      <PostulationPage
        orgToken={orgToken}
        token={token}
        tenant={tenant}
      />
    </Suspense>
  )
};

export default Postulation;
